import {Component, OnInit, ViewChild} from '@angular/core';
import {ArticleDataModel} from "../../../../core/services/portal-data/article-data.model";
import {PortalDataService} from "../../../../core/services/portal-data/portal-data.service";
import {UtilService} from "../../../../core/services/util/util.service";
import {DialogComponent} from "@syncfusion/ej2-angular-popups";
import {ButtonPropsModel} from "@syncfusion/ej2-popups/src/dialog/dialog-model";
import {$translate} from "../../../../core/services/internationalization/localize.service";

@Component({
  selector: 'sb-portal-articles,sb-dynamic-portal-articles',
  templateUrl: './portal-articles.component.html',
  styleUrls: ['./portal-articles.component.scss']
})
export class PortalArticlesComponent implements OnInit {

  @ViewChild('ejDialog', {static: false}) ejDialog: DialogComponent;

  loadQuantity = 2;

  articles: ArticleDataModel[] = [];

  numLoaded: number = 0;

  modalArticle: ArticleDataModel = null;

  buttons: ButtonPropsModel[] = [
    {
      'click': () => { this.ejDialog.hide() },
      buttonModel: {
        content: $translate("common.button.close")`Close`,
        isPrimary: true,
      }
    },
  ];

  constructor(private portalDataService: PortalDataService, private utilService: UtilService) { }

  ngOnInit() {
    this.loadMore();
  }

  ngOnDestroy() {
  }

  async loadMore() {
    const more = await this.portalDataService.getArticles(this.numLoaded, this.loadQuantity);
    const currentArticles: string[] = this.articles.map((a) => a.id);
    const newArticles = more.filter((a) => !currentArticles.includes(a.id));
    this.articles.push(...newArticles);
    this.numLoaded = this.articles.length;
  }

  openModal(item: ArticleDataModel) {
    this.modalArticle = item;
    this.utilService.tickThen(() => {
      this.ejDialog.show();
    });
  }

  onClose($event: any) {
    this.ejDialog.hide();
    this.modalArticle = null;
  }
}
